import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

export const SearchIcon = () => (
    <FontAwesomeIcon className="search-icon" icon={faSearch} />
)
export default SearchIcon;




// WEBPACK FOOTER //
// ./src/components/icons/SearchIcon.js